import { render, staticRenderFns } from "./ShopifyIcon.vue?vue&type=template&id=278b1bd0&scoped=true&"
import script from "./ShopifyIcon.vue?vue&type=script&lang=js&"
export * from "./ShopifyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b1bd0",
  null
  
)

export default component.exports